import React, { useContext } from "react";
import QWrapper from "./QWrapper.js";
import QTitle from "./QTitle.js";
import LanguageContext from "./../contexts/languageContext.js";
import I18N from "./I18N.js";

const TextQuestion = ({
  label,
  options,
  mandatory,
  id,
  handler,
  formState,
}) => {
  const { language, rtl } = useContext(LanguageContext);
  const maxChars = options.maxChars ? options.maxChars : 1000;
  const currLength = formState[id] ? formState[id].length : 0;
  const optional = I18N("optional", language);
  return (
    <QWrapper key={id}>
      <QTitle>{label[language]}</QTitle>
      {!mandatory && (
        <small className={`${rtl ? "text-end" : "d-text-start"} d-block px-1`}>
          {optional}
        </small>
      )}
      <div className="form-floating">
        <textarea
          className="form-control"
          placeholder="Leave a comment here"
          id={`a${id}_floatingTextarea2`}
          maxLength={maxChars}
          style={{ height: "170px", direction: rtl ? "rtl" : "ltr" }}
          onChange={(e) => {
            handler(id, e.target.value);
          }}
          defaultValue={
            formState.hasOwnProperty(id) && formState[id] ? formState[id] : ""
          }
        />
        <small
          className={`mt-1 d-block text-center ${
            currLength > 0.9 * maxChars && currLength < maxChars
              ? "fw-semibold"
              : currLength === maxChars
              ? "fw-semibold text-danger"
              : ""
          } `}
        >{`${currLength}/${maxChars}`}</small>
      </div>
    </QWrapper>
  );
};

export default TextQuestion;
